module.exports = __webpack_public_path__ + "img/transporte.23946322.png";